/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import {
  Modal,
} from 'react-bootstrap';
import {
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  list: PropTypes.array.isRequired,
  fail: PropTypes.array,
  showModal: PropTypes.bool.isRequired,
};

const defaultProps = {
  fail: [],
};

class GatewayList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: props.list,
      showModal: props.showModal,
      fail: props.fail,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.broadcast');
  }

  componentWillReceiveProps(nextProps) {
    const { list, showModal, fail } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (list !== this.props.list) {
      this.setState({ list });
    }
    if (!_.isEqual(fail, this.props.fail)) {
      this.setState({ fail });
    }
  }

  render() {
    const { showModal, list, fail } = this.state;
    return (
      <Modal
        show={showModal}
        onHide={this.props.onHide}
        bsClass="aisz-modal-light"
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('logs.gateway')}
        </Modal.Header>
        <Modal.Body className={`clearfix ${styles.lists}`}>
          <div className={styles.success}>
            <div className={styles.successTitle}>
              {this.intlMsg.msg('logs.success')}
            </div>
            {
              _.map(list, l => (
                <div key={l} className={styles.cols}>
                  <Link to={`/gateway/detail/${l}`}>
                    {normalizeDevEUI(l)}
                  </Link>
                </div>
              ))
            }
          </div>
          <div className={styles.fail}>
            <div className={styles.title}>
              {this.intlMsg.msg('logs.fail')}
            </div>
            {
              _.map(fail, f => (
                <div key={f} className={styles.cols}>
                  <Link to={`/gateway/detail/${f}`}>
                    {normalizeDevEUI(f)}
                  </Link>
                </div>
              ))
            }
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

GatewayList.propTypes = propTypes;
GatewayList.defaultProps = defaultProps;

export default injectIntl(GatewayList);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/GatewayList/index.jsx